import { IN_CAMPAIGN_FILTER_NAME } from "@signalist/shared-types";

/**
 * Dropdown filters whose options load as soon as the filter is opened, without a search term:
 * short, fixed lists where typing first would only get in the way. "In campaign" (PREC-4163) is
 * one: the user picks from the workspace's campaigns rather than recalling a name.
 */
const EAGER_OPTION_FILTERS: ReadonlySet<string> = new Set([
	"overallScore",
	"companyCategory",
	"personaCategory",
	"roleChangeType",
	"companyCategoryType",
	"seniority",
	"reportedEmployees",
	IN_CAMPAIGN_FILTER_NAME,
]);

/** Whether the dropdown filter `name` loads its options before the user has typed. */
export const loadsOptionsWithoutSearch = (name: string): boolean => EAGER_OPTION_FILTERS.has(name);
